import * as styles from "./PaginationDots.css";

import type { ReactNode } from "react";

import { useLingui } from "@lingui/react/macro";

import type { PaginationPageListProps } from "./Pagination.types";
import { ELLIPSIS_SLOT } from "./constants";
import { ELLIPSIS } from "./getPaginationRange";

export function PaginationDots({
  range,
  page,
  size,
  disabled,
  onPageChange,
}: PaginationPageListProps): ReactNode {
  const { t } = useLingui();

  return range.map((item, index) =>
    item === ELLIPSIS ? (
      <span
        key={`ellipsis-${index}`}
        data-slot={ELLIPSIS_SLOT}
        className={styles.dotEllipsis}
        aria-hidden="true"
      />
    ) : (
      <button
        key={item}
        type="button"
        className={styles.dot({ size, current: item === page })}
        disabled={disabled}
        aria-label={t`Page ${item}`}
        aria-current={item === page ? "page" : undefined}
        onClick={() => onPageChange(item)}
      />
    ),
  );
}
